<template>
  <v-card :loading="loading" flat>
    <MiniEquity :data="data" source="trades" />
  </v-card>
</template>
    

<script>
import axios from "axios";
import MiniEquity from "@/components/minicharts_v2/miniEquity.vue";
export default {
  components: { MiniEquity },
  data() {
    return {
      loading: false,
      data: {}
    };
  },
  mounted() {
    this.getStats();
  },
  methods: {
    getStats() {
      this.loading = true;
      axios
        .post("https://tradeinpool.com:3001/api/request/Trades/", {
          method: "allPL"
        })
        .then(response => {
          this.loading = false;
          this.data = response.data;
        });
    }
  },
  sockets: {
  UPDATE_STATS: function(data) {
      this.data = data
      }
  }
};
</script>

<style>
</style>